import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "@/api/statusHTTP";

export const buscarProdutoCompraDistribuidoPorFilial = async (params) => {
  const url = '/compras/distribuicao-por-filiais/produtos';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  const {token, produtos, sugestao_grupo, preco_custo_grupo} = data;
  localStorage.token = token;
  return {produtos, sugestao_grupo, preco_custo_grupo};
}

export const buscarDetalhamentoCarrinhosOndeProdutoEsta = async (params) => {
  const url = '/compras/distribuicao-por-filiais/detalhamento-carrinhos';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.carrinhos;
}

class CompraAPI {

  async getDadosGraficoFornecedor(headers, params) {
    const response = await api.get("/dash_grafico", {
      params,
      headers
    });
    return response;
  }

  async getDadosGraficoFornecedorGrupo(headers, params) {
    const response = await api.get("/dash_grafico_grupos", {
      params,
      headers
    });
    return response;
  }

  async getProdutosCompraGrupo(headers, params) {
    const response = await api.get('/compras_listaprodutos_grupo', {
      params,
      headers
    });
    return response;
  }

  async getProdutosCompraGeralGrupo(headers, params) {
    const response = await api.get('/compras_listaprodutosgeral_grupo', {
      params,
      headers
    });
    return response;
  }

  async getProdutosTransitoGrupo(headers, params) {
    const response = await api.get('/compras_listaprodutos_transito_grupo', {
      params,
      headers
    });
    return response;
  }

  async getProdutosSobEncomendaGrupo(headers, params) {
    const response = await api.get('/compras_listaprodutos_sobencomenda_grupo', {
      params,
      headers
    });
    return response;
  }

  async getDetalhesProdutoGrupo(headers, params) {
    const response = await api.get('/compras_detalheproduto_grupo', {
      params,
      headers
    });
    return response;
  }

  async getAnaliseProdutoGrupo(headers, params) {
    return await api.get('/compras_analiseproduto_grupo', {params, headers});
  }

  async getUltimasComprasGrupo(headers, params) {
    const response = await api.get('/compras_listacompras_grupo', {
      params,
      headers
    });
    return response;
  }

  async getTotaisGrupo(headers, params) {
    const response = await api.get("/compras_get_totais_itens_grupo", {
      params,
      headers
    });
    return response;
  }

  async getPedidoGrupo(headers, params) {
    const response = await api.get('/get_pedido_grupo', {
      params,
      headers
    });
    return response;
  }

  async getProdutosSimilares(headers, params) {
    const response = await api.get('/listagem_produtos_grupo', {
      params,
      headers
    });
    return response;
  }

  async getSimilares(headers, params) {
    const response = await api.get('/busca_similares_grupo', {
      params,
      headers
    });
    return response;
  }

  async addSimilares(headers, params) {
    const response = await api({
      method: 'post',
      url: '/add_similares',
      headers,
      data: params
    });
    return response;
  }

  async deleteSimilares(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_similares',
      headers,
      data: params
    });
    return response;
  }

  async ajustarTempoRessuprimentoGrupo(headers, params) {
    const response = await api({
      method: 'post',
      url: '/ajuste_ressuprimento_grupo',
      headers,
      data: params
    });
    return response;
  }

  async getDetalhesMovimentacaoGrupo(headers, params) {
    const response = await api.get('/getDetalhesMovimentacaoGrupo', {
      params,
      headers
    });
    return response;
  }

  async getAnaliseTendenciaGrupo(headers, params) {
    const response = await api.get('/getAnaliseTendencia_grupo', {
      params,
      headers
    });
    return response;
  }

  async getDetalhamentoEstoqueGrupo(headers, params) {
    const response = await api.get('/getDetalhamentoEstoqueGrupo', {
      params,
      headers
    });
    return response;
  }

  async getFiliais(headers, params) {
    const response = await api.get("/getFiliaisDrpGrupo", {
      params,
      headers
    });
    return response;
  }

  async setFatorAtuacao(headers, params) {
    const response = await api({
      method: 'put',
      url: '/set_fator_atuacao',
      headers,
      data: params
    });
    return response;
  }

  async getMotivoBlacklistProduto(headers) {
    const response = await api.get("/get_motivo_blacklist_produto", {
      headers
    });
    return response;
  }

  async silenciarProduto(headers, params) {
    const response = await api({
      method: 'post',
      url: '/silenciar_produto',
      headers,
      data: params
    });
    return response;
  }

  async getProdutosSilenciados(headers, params) {
    const response = await api.get("/get_produtos_silenciados", {
      headers,
      params
    });
    return response;
  }

  async getProdutoSilenciado(headers, params) {
    const response = await api.get("/get_produto_silenciado", {
      headers,
      params
    });
    return response;
  }

  async delProdutoSilenciado(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_produto_silenciado',
      headers,
      data: params
    });
    return response;
  }

  async getQtdeProdutosSilenciados(headers, params) {
    const response = await api.get("/get_qtde_produtos_silenciados", {
      headers,
      params
    });
    return response;
  }

  async getProdutosSobDemanda(headers, params) {
    const response = await api.post("/get_produtos_sob_demanda", params, {headers});
    return response;
  }

  async setProdutosHeranca(headers, params) {
    const response = await api({
      method: 'post',
      url: '/set_produtos_heranca',
      headers,
      data: params
    });
    return response;
  }

  async getSaidasProdutos(headers, params) {
    const response = await api.get("/get_saidas_produtos", {
      headers,
      params
    });
    return response;
  }

  async getMotivos(headers) {
    const response = await api.get("/get_motivos", {
      headers
    });
    return response;
  }

  async setMotivos(headers, params) {
    const response = await api({
      method: 'post',
      url: '/set_motivos',
      headers,
      data: params
    });
    return response;
  }

  async delMotivo(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_motivo',
      headers,
      data: params
    });
    return response;
  }

  async getEmbalagem(headers, params) {
    const response = await api.get("/get_embalagem", {
      headers,
      params
    });
    return response;
  }

  async setEmbalagem(headers, params) {
    const response = await api({
      method: 'post',
      url: '/set_embalagem',
      headers,
      data: params
    });
    return response;
  }

  async converterEmbalagem(headers, params) {
    const response = await api({
      method: 'post',
      url: '/converter_embalagem',
      headers,
      data: params
    });
    return response;
  }

  async getMotivosCompraOportunidade(headers, params) {
    const response = await api.get("/get_motivos_compra_oportunidade", {
      headers,
      params
    });
    return response;
  }

  async setMotivosCompraOportunidade(headers, params) {
    const response = await api({
      method: 'post',
      url: '/set_motivos_compra_oportunidade',
      headers,
      data: params
    });
    return response;
  }

  async delMotivoCompraOportunidade(headers, params) {
    const response = await api({
      method: 'delete',
      url: '/delete_motivo_compra_oportunidade',
      headers,
      data: params
    });
    return response;
  }

  async getMotivosCompra(headers, params) {
    const response = await api.get("/get_motivos_compra", { headers, params });
    return response;
  }

  async getValidadesLotes(headers, params) {
    const response = await api.get("/get_validades_lotes", {
      headers, params
    });
    return response;
  }

  async getConfigsFornecedor(headers, params) {
    const response = await api.get("/get_configs_fornecedor", { headers, params });
    return response;
  }

  async setConfigsFornecedor(headers, params) {
    const response = await api({
      method: 'post',
      url: '/set_configs_fornecedor',
      headers,
      data: params
    });
    return response;
  }

  async atualizarFiltrosProfutosFornecedor(headers, params) {
    const response = await api({
      method: 'post',
      url: '/atualizar_filtros_profutos_fornecedor',
      headers,
      data: params
    });
    return response;
  }

  async atualizarCoberturaManualProduto(headers, params) {
    const response = await api({
      method: 'post',
      url: '/atualizar_cobertura_manual_produto',
      headers,
      data: params
    })
    return response;
  }

  async getDataLimiteFornecedor(headers, params) {
    const response = await api.get("/get_data_limite_fornecedor", { headers, params });

    return response;
  }

  async getNotificacaoProdutoValidadeLotes(headers, params) {
    const response = await api.get("/get_notificacao_produto_validade_lotes", {
      headers,
      params
    });

    return response;
  }

  async getProdutoValidadesTodosLotes(headers, params) {
    const response = await api.get("/get_produto_validade_todos_lotes", {
      headers, params
    });

    return response;
  }

  async getListaProdutosAgrupados(headers, params) {
    const response = await api({
      method: "post",
      url: "/compra_multifliais_get_lista_produtos_compra",
      headers,
      data: params
    });
    return response;
  }

  async getProdutoPorTodasFiliais(headers, params) {
    return await api.get("/compra_multifliais_get_produto_por_filial", {headers, params})
  }

  async addProdutoFullNoCarrinho(headers, params) {
    return await api({
      method: "post",
      url: "/compra_multifiliais_add_produto_full_no_carrinho",
      headers,
      data: params
    });
  }

  async mapaCompra(headers, params) {
    return await api({
      method: 'post',
      url: '/mapa_compra',
      headers,
      data: params
    })
  }
}

export default new CompraAPI();
